import React, { FunctionComponent } from "react";
import { Grid, Table, IconButton, MuiThemeProvider } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
//import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import MUIDataTable from "mui-datatables";
import { useTableStyles } from "../../useTableStyle";
import { useVoucherStyles } from "../useVoucherStyles";

const emptyOptions = {
  pagination: false,
  selectableRows: undefined,
  selectableRowsHeader: false,
  print: false,
  search: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

const columns = ["Amount", "Status"];

const options = {
  selectableRows: undefined,
  selectableRowsHeader: false,
  rowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
  print: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

interface ReferenceList {
  voucherDetails: Array<Object>;
  closeVoucherDetailsDialog: () => void;
  voucherName: string;
}
export const VoucherDetailsList: FunctionComponent<ReferenceList> = ({
  voucherDetails,
  closeVoucherDetailsDialog,
  voucherName,
}) => {
  const classes = useVoucherStyles();
  const getMuiTheme = useTableStyles();
  if (voucherDetails && voucherDetails.length > 0) {
    return (
      <div>
        <Dialog open maxWidth="md" fullWidth={true}>
          <DialogContent>
            <Grid container>
              <Grid item>
                <DialogContentText
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "1.5em",
                  }}
                ></DialogContentText>
              </Grid>
              <Grid item>
                <IconButton
                  aria-label="close"
                  className={classes.closeButton}
                  onClick={closeVoucherDetailsDialog}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Table>
                <MuiThemeProvider theme={getMuiTheme}>
                  <MUIDataTable
                    title={"Voucher Details of " + voucherName}
                    data={voucherDetails.map((data: any) => {
                      return [
                        data.amount,
                        data.is_active ? "Active" : "Inactive",
                      ];
                    })}
                    columns={columns}
                    options={options}
                  />
                </MuiThemeProvider>
              </Table>
            </Grid>
          </DialogContent>
        </Dialog>
      </div>
    );
  } else {
    return (
      <div>
        <Table>
          <MuiThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Voucher Details List"}
              columns={columns}
              data={[]}
              options={emptyOptions}
            />
          </MuiThemeProvider>
        </Table>
      </div>
    );
  }
};
